export default __webpack_public_path__ + "static/media/img_nvi1.6e36df9a.jpg";